module.exports = __webpack_public_path__ + "assets/img/search_black.3851a6d9.png";